import React from 'react';
import PatientOptionAvatar from '@common/assets/svg/patient-options-avatar.svg';
import styled from 'styled-components';
import { IPatientSelectOption } from './types';

interface PatientSelectOptionProps {
  data: IPatientSelectOption;
  innerProps: Record<string, any>;
}

const PatientOption: React.FunctionComponent<PatientSelectOptionProps> = ({
  data,
  innerProps,
}) => {
  return (
    <PatientSelectOptionSC {...innerProps} className={'option'}>
      <div className={'root'}>
        <div className={'avatar'}>
          <img
            src={data.image || PatientOptionAvatar}
            alt={data.label}
            width="16"
            height="16"
          />
        </div>
        <div className={'option-meta'}>
          <span className={'label'}>{data.label}</span>
          <span className={'email'}>{data.email}</span>
        </div>
      </div>
    </PatientSelectOptionSC>
  );
};

const PatientSelectOptionSC = styled.div`
  padding-left: 12px;
  padding-right: 12px;
  cursor: pointer;

  .root {
    display: flex;
    padding: 8px;
    overflow: hidden;

    &:hover {
      background: rgba(235, 236, 240, 0.5);
      border-radius: 8px;
    }

    .option-meta {
      display: flex;
      flex-direction: column;
      width: 85%;

      .label,
      .email {
        font-size: 14px;
        line-height: 14px;
        color: #333d6c;
        margin-left: 10px;
        overflow-wrap: break-word;
      }

      .label {
        font-weight: bold;
        margin-bottom: 2px;
      }
    }

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      max-width: 40px;

      img {
        width: 100%;
        height: auto;
        border-radius: 50%;
      }
    }
  }
`;

export default React.memo(PatientOption);
